import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  AttachmentItem,
  CardComponent,
} from '@sportello-balneari/shared-components';
import { TableModule } from 'primeng/table';
import { TenderContextService } from '../../../services/compiling/state/tender-context.service';
import { TenderLotDetailsComponent } from '../envelope-b/tender-lot-details.component';

@Component({
  selector: 'lib-compiling-summary',
  template: `
    <div class="flex w-full flex-col gap-6">
      <lib-card>
        <ng-container title>Bando</ng-container>
        <ng-container content>
          <div
            class="grid grid-cols-1 gap-4 pt-4 tracking-tighter md:grid-cols-2"
          >
            <div>
              <div>Data di pubblicazione</div>
              <div class="mt-1 font-semibold">
                {{
                  tenderContext.tenderInfo()?.publicationDate
                    | date: 'd MMMM yyyy'
                }}
              </div>
            </div>

            <div>
              <div>Data e ora di scadenza</div>
              <div class="mt-1 font-semibold">
                {{
                  tenderContext.tenderInfo()?.expiryDate
                    | date: 'd MMMM yyyy HH:mm'
                }}
              </div>
            </div>

            <div>
              <div>Durata concessione minima</div>
              <div class="mt-1 font-semibold">
                {{ tenderContext.tenderInfo()?.concessionPeriodYears }} anni
              </div>
            </div>
            <div>
              <div>Durata concessione massima</div>
              <div class="mt-1 font-semibold">
                {{ tenderContext.tenderInfo()?.concessionPeriodMaxYears }}
                anni
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-4 border-t border-gray-100 pt-6">
            <span class="font-semibold text-gray-700"
              >Documentazione ufficiale</span
            >
            @if (
              tenderContext.tenderInfo()?.attachments &&
              tenderContext.tenderInfo()?.attachments!.length > 0
            ) {
              <ul class="grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
                @for (
                  attachment of tenderContext.tenderInfo()?.attachments;
                  track $index
                ) {
                  <lib-attachment-item
                    [fileName]="attachment.fileName"
                    [downloadUrl]="attachment.url"
                    [showDownload]="true"
                  />
                }
              </ul>
            } @else {
              <div
                class="rounded-xl border-2 border-dashed border-gray-200 py-6 text-center text-sm italic text-gray-400"
              >
                Nessuna documentazione ufficiale.
              </div>
            }
          </div>
        </ng-container>
      </lib-card>

      <lib-tender-lot-details />
    </div>
  `,
  imports: [
    CardComponent,
    TenderLotDetailsComponent,
    DatePipe,
    TableModule,
    AttachmentItem,
  ],
})
export class SummaryComponent {
  protected readonly tenderContext = inject(TenderContextService);
}
